import { Moon, Sun } from "lucide-react"
import { Button } from "@pagespeedify/ui"
import { useTheme } from "./ThemeProvider"

export function ThemeToggle() {
  // Get current theme and setter function
  const { theme, setTheme } = useTheme()

  // Function to toggle between light and dark
  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <Button variant="ghost" size="icon" onClick={toggleTheme} className="h-8 w-8">
      {/* Show Sun icon if current theme is light */}
      <Sun className={`h-4 w-4 transition-all ${theme === 'light' ? 'rotate-0 scale-100' : '-rotate-90 scale-0'}`} />
      {/* Show Moon icon if current theme is dark */}
      <Moon className={`absolute h-4 w-4 transition-all ${theme === 'dark' ? 'rotate-0 scale-100' : 'rotate-90 scale-0'}`} />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}